import { CarState } from "types/cars";
import { MapExperience } from "types/map";
import { RepairForm } from "types/restarter";

export const getNeutralCar = (): CarState => ({
  id: "",
  licensePlate: "",
  genericVin: "SCFSMGAW",
  carBrand: "aston martin",
  carModel: "vantage",
  emissionCO2: 236,
  emissionType: "gasoline",
  nextControl: "",
  previousControl: "",
});

export const getNeutralExperience = (): MapExperience => ({
  experienceId: "shed-norway-rainforest-foundation",
  valueImpact: 0,
  iconMarkers: [],
  cardMarkers: [],
});

export const getNeutralRepairForm = (): RepairForm => ({
  id: "",
  eventCode: "",
  item: "",
  category: null,
  brand: "",
  model: "",
  priceAsNew: 0,
  age: "",
  assessment: "",
  weight: "",
  status: "IN PROGRESS",
  agreed: false,
  fullname: "",
  email: "",
});
